const organization_details = {
    departments: {
        leader: 'Responsabile',
        leaders: 'Responsabili del reparto',
        led_departments: 'Reparti gestiti',
        edit_leaders: 'Gestisci responsabili',
        add_leader: 'Aggiungi',
        remove_leader: 'Rimuovi',
        no_leaders: 'Nessun responsabile',
        local: 'Gestione locale',
        managed_members: 'Membri nel proprio ambito',
        leader_scope_hint: 'Gestisci le assegnazioni dei tuoi reparti e sottoreparti.',
        leader_permission_hint: 'I responsabili gestiscono le assegnazioni dei propri reparti e sottoreparti, senza modificare ruoli o gerarchie.',
        primary_synced: 'Il reparto principale è gestito da Feishu.',
        status_active: 'Attivo',
        status_suspended: 'Sospeso',
        status_departed: 'Uscito',
        status_pending: 'In attesa di attivazione',
        search: 'Cerca',
        previous_page: 'Pagina precedente',
        next_page: 'Pagina successiva',
        directory_title: 'Membri dell’organizzazione',
        member_name: 'Membro',
        search_members: 'Cerca per nome o nome utente',
        include_descendants: 'Includi sottoreparti',
        no_members: 'Nessun membro corrispondente.',
        all_members: 'Tutti i membri',
        all_departments: 'Tutti i reparti',
        edit_member: 'Modifica reparti',
        add_child: 'Aggiungi sottoreparto',
        expand_department: 'Espandi {{name}}',
        collapse_department: 'Comprimi {{name}}',
        title: 'Reparti',
        description: 'Gestisci i reparti e le assegnazioni dei membri di questa organizzazione.',
        create: 'Crea reparto',
        edit: 'Modifica reparto',
        name: 'Nome del reparto',
        parent: 'Reparto superiore',
        root: 'Nessun reparto superiore',
        id: 'ID reparto',
        members: 'Reparti dei membri',
        member_id: 'ID utente del membro',
        primary: 'Reparto principale',
        none: 'Non impostato',
        assignments: 'Assegnazioni ai reparti',
        no_assignments: 'Nessuna assegnazione ai reparti.',
        assignment_hint: 'Assegna reparti locali e, facoltativamente, un reparto principale. Le assegnazioni della directory sono di sola lettura.',
        empty: 'Nessun reparto.',
        readonly: 'Puoi visualizzare i reparti e le tue assegnazioni. Contatta un amministratore per modificarle.',
        load_error: 'Impossibile caricare i dati. Riprova.',
        mutation_error: 'Salvataggio non riuscito. Controlla permessi, appartenenza e gerarchia dei reparti.',
        loading: 'Caricamento…',
        synced: 'Gestito dalla directory',
        choose: 'Cerca reparti',
        organizations_title: 'Organizzazioni e reparti',
        organizations_description: 'Scegli un’organizzazione per visualizzare o gestire i suoi reparti.',
        no_organizations: 'Non appartieni ad alcuna organizzazione. Contatta un amministratore.',
        organization: 'Organizzazione attuale',
        choose_organization: 'Scegli un’organizzazione',
        delete_title: 'Elimina reparto',
        delete_description: 'Eliminare «{{name}}»? Sposta prima i membri e i sottoreparti.',
    },
    directory: {
        leaders_label: 'Responsabilità dei reparti',
        local_department_leader: 'Responsabile assegnato localmente',
        status_active: 'Attivo',
        status_suspended: 'Sospeso',
        status_departed: 'Uscito',
        status_pending: 'In attesa di attivazione',
        profiles_label: 'Profili di origine',
        primary_label: 'Modifiche del reparto principale',
        deactivated_label: 'Identità disattivate',
        reactivated_label: 'Identità riattivate',
        lifecycle_notice: 'Assegnazioni di ruolo conservate: {{count}}. La riattivazione ripristina le autorizzazioni precedenti.',
        title: 'Directory Feishu',
        description: 'Importa reparti e membri in questa organizzazione tramite un connettore Feishu.',
        identity_notice: 'Usa un connettore con provisioning della directory abilitato. Cambiare l’identità di un connettore esistente richiede la migrazione degli account.',
        connector: 'ID connettore Feishu',
        preview: 'Anteprima sincronizzazione',
        preview_title: 'Anteprima sincronizzazione',
        preview_description: 'Controlla la directory prima di importare. Se cambia, genera una nuova anteprima.',
        import: 'Conferma sincronizzazione',
        success: 'Importati {{departments}} reparti e {{users}} membri; creati {{createdUsers}} account. Rimossi {{removedDepartments}} reparti, {{removedMemberships}} appartenenze e {{removedAssignments}} assegnazioni.',
        failure: 'Impossibile leggere o importare la directory. Controlla permessi e visibilità del connettore e ripeti l’anteprima.',
        behavior_title: 'Modalità di importazione',
        mode: 'Sincronizza nomi, avatar, reparti e reparti principali. I membri assenti o inattivi perdono accesso solo a questa organizzazione; ruoli, assegnazioni locali, account globali e altre identità restano invariati. E-mail e telefono sono dati di origine, non credenziali di accesso.',
        limits: 'Per importazione: 1000 reparti, 5000 utenti, 10000 assegnazioni; lettura limitata a 60 secondi. Importazioni incomplete o eccessive vengono rifiutate.',
        counts: '{{departments}} reparti · {{users}} membri',
        departments_label: 'Reparti',
        members_label: 'Appartenenze alle organizzazioni',
        assignments_label: 'Assegnazioni ai reparti',
        item: 'Elemento',
        added: 'Aggiungi',
        updated: 'Aggiorna',
        removed: 'Rimuovi',
        cleanup_notice: 'Sincronizza nomi, avatar, reparti e reparti principali. I membri assenti o inattivi perdono accesso solo a questa organizzazione; ruoli, assegnazioni locali, account globali e altre identità restano invariati. E-mail e telefono sono dati di origine, non credenziali di accesso.',
        conflicts_title: '{{count}} conflitti bloccano la sincronizzazione. Risolvi le dipendenze locali e ripeti l’anteprima.',
        removals_title: 'Esempi di rimozioni (massimo 20 per categoria)',
        local_child_department: 'Sottoreparto locale',
        unowned_assignment: 'Assegnazione locale o precedente senza origine verificata',
        local_member_roles: 'Il membro ha ruoli assegnati localmente',
        unlinked_identity: 'L’identità della directory è stata scollegata',
    },
    page_title: "Dettagli dell'organizzazione",
    delete_confirmation: "Una volta eliminato, tutti i membri perderanno la loro iscrizione e ruoli in questa organizzazione. Quest'azione non può essere annullata.",
    organization_id: 'ID organizzazione',
    settings_description: 'Le organizzazioni rappresentano i team, i clienti aziendali e le società partner che possono accedere alle tue applicazioni.',
    name_placeholder: "Il nome dell'organizzazione, non è necessario che sia univoco.",
    description_placeholder: "Una descrizione dell'organizzazione.",
    member: 'Membro',
    member_other: 'Membri',
    add_members_to_organization: "Aggiungi membri all'organizzazione {{name}}",
    add_members_to_organization_description: 'Trova gli utenti appropriati cercando per nome, email, telefono o ID utente. Gli utenti già esistenti non vengono mostrati nei risultati della ricerca.',
    add_with_organization_role: "Aggiungi con ruolo(i) dell'organizzazione",
    user: 'Utente',
    application: 'Applicazione',
    application_other: 'Applicazioni',
    add_applications_to_organization: "Aggiungi applicazioni all'organizzazione {{name}}",
    add_applications_to_organization_description: 'Trova applicazioni appropriate cercando per ID app, nome o descrizione. Le applicazioni esistenti non vengono mostrate nei risultati della ricerca.',
    at_least_one_application: 'È richiesta almeno una applicazione.',
    remove_application_from_organization: "Rimuovi applicazione dall'organizzazione",
    remove_application_from_organization_description: "Una volta rimossa, l'applicazione perderà la sua associazione e ruoli in questa organizzazione. Quest'azione non può essere annullata.",
    search_application_placeholder: 'Cerca per ID app, nome o descrizione',
    roles: "Ruoli dell'organizzazione",
    authorize_to_roles: 'Autorizza {{name}} ad accedere ai seguenti ruoli:',
    edit_organization_roles: "Modifica ruoli dell'organizzazione",
    edit_organization_roles_title: "Modifica ruoli dell'organizzazione di {{name}}",
    remove_user_from_organization: "Rimuovi utente dall'organizzazione",
    remove_user_from_organization_description: "Una volta rimosso, l'utente perderà la sua iscrizione e i ruoli in questa organizzazione. Quest'azione non può essere annullata.",
    search_user_placeholder: 'Cerca per nome, email, telefono o ID utente',
    at_least_one_user: 'È richiesto almeno un utente.',
    organization_roles_tooltip: "I ruoli assegnati al {{type}} all'interno di questa organizzazione.",
    custom_data: 'Dati personalizzati',
    custom_data_tip: "I dati personalizzati sono un oggetto JSON che può essere utilizzato per archiviare dati aggiuntivi associati all'organizzazione.",
    invalid_json_object: 'Oggetto JSON non valido.',
    branding: {
        name: 'Marchio',
        description: "Personalizza l'esperienza di accesso a livello di organizzazione.",
        organization_level_sie: 'Esperienza di accesso a livello di organizzazione',
        organization_level_sie_switch: "Abilita l'esperienza di accesso a livello di organizzazione e configura il branding specifico. Se disabilitato, esegue il fallback prima all'accesso a livello di applicazione e poi all'esperienza di accesso omni.",
        logo: "Loghi dell'organizzazione",
        logo_tooltip: "Puoi passare l'ID dell'organizzazione per visualizzare questo logo nell'esperienza di accesso; è necessaria la versione scura del logo se la modalità scura è abilitata nelle impostazioni dell'esperienza di accesso omni. <a>Scopri di più</a>",
    },
    jit: {
        title: 'Provisioning just-in-time',
        description: "Gli utenti possono unirsi automaticamente all'organizzazione e ricevere ruoli al primo accesso attraverso alcuni metodi di autenticazione. Puoi impostare i requisiti da soddisfare per il provisioning just-in-time.",
        email_domain: 'Provisioning dominio email',
        email_domain_description: "I nuovi utenti che si iscrivono con i loro indirizzi email verificati o tramite accesso sociale con indirizzi email verificati si uniranno automaticamente all'organizzazione. <a>Scopri di più</a>",
        email_domain_placeholder: 'Inserisci domini email per il provisioning just-in-time',
        invalid_domain: 'Dominio non valido',
        domain_already_added: 'Dominio già aggiunto',
        sso_enabled_domain_warning: 'Hai inserito uno o più domini email associati a SSO aziendale. Gli utenti con queste email seguiranno il flusso SSO standard e non verranno provisionati in questa organizzazione a meno che il provisioning SSO aziendale non sia configurato.',
        enterprise_sso: 'Provisioning SSO aziendale',
        no_enterprise_connector_set: 'Non hai ancora configurato alcun connettore SSO aziendale. Aggiungi prima i connettori per abilitare il provisioning SSO aziendale. <a>Imposta</a>',
        add_enterprise_connector: 'Aggiungi connettore aziendale',
        enterprise_sso_description: "I nuovi utenti o gli utenti esistenti che accedono tramite SSO aziendale per la prima volta si uniranno automaticamente all'organizzazione. <a>Scopri di più</a>",
        organization_roles: 'Ruoli organizzazione predefiniti',
        organization_roles_description: "Assegna ruoli agli utenti all'atto dell'iscrizione all'organizzazione tramite il provisioning just-in-time.",
    },
    mfa: {
        title: 'Autenticazione multifattore (MFA)',
        tip: "Quando è richiesta l'MFA, agli utenti senza MFA configurata verrà negato l'accesso quando tenteranno di scambiare un token dell'organizzazione. Questa impostazione non influisce sull'autenticazione dell'utente.",
        description: "Richiedi agli utenti di configurare l'autenticazione multifattore per accedere a questa organizzazione.",
        no_mfa_warning: 'Nessun metodo di autenticazione multifattore è abilitato per il tuo tenant. Gli utenti non potranno accedere a questa organizzazione finché non viene abilitato almeno un <a>metodo di autenticazione multifattore</a>.',
    },
};
export default Object.freeze(organization_details);
